import { render, staticRenderFns } from "./GroupFeeListComp.vue?vue&type=template&id=6c8923a0&scoped=true"
import script from "./GroupFeeListComp.vue?vue&type=script&lang=js"
export * from "./GroupFeeListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8923a0",
  null
  
)

export default component.exports